import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Component } from "react";
import { NavLink } from "react-router-dom";
import { Container } from "reactstrap";

class PagePath extends Component {
    constructor(props) {
        super(props);
    }
    render() { 
        const pages = this.props.pages
        const links = this.props.links
        const pagesDivs = pages.map((pageTitle,i) => 
        <>
          <NavLink className="pageLinks" to={links ? links[0] : "/home"}>
           {pageTitle}
          </NavLink>
          <FontAwesomeIcon
          className="align-self-center faChevron mb-0"
          icon={faChevronRight}
        ></FontAwesomeIcon>
        </>
        );
        return ( 
            <Container className="linksContainer d-none d-md-flex justify-content-start">
            {pagesDivs}
          </Container>
         );
    }
}
 
export default PagePath;